import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    paddingRight: 7,
    paddingLeft: 12,
  },
  graphHeader: {
    paddingTop: 10,
    paddingBottom: 7,
  },
  footerRow: {
    paddingBottom: 14,
  },
  seeTransactionsView: {
    width: 175
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  graphDisplay: {
    display: 'block'
  }
});
